// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"6c6b1e8c","479":"6c6b1e8c","746":"49a9a2ec","786":"6c6b1e8c"}[chunkId] + ".chunk.css";
};